import { render, staticRenderFns } from "./GlobalButtonCircle.vue?vue&type=template&id=0bcce7fc&scoped=true"
import script from "./GlobalButtonCircle.vue?vue&type=script&lang=js"
export * from "./GlobalButtonCircle.vue?vue&type=script&lang=js"
import style0 from "./GlobalButtonCircle.vue?vue&type=style&index=0&id=0bcce7fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcce7fc",
  null
  
)

export default component.exports